<script>
  import {Link, navigateTo} from 'yrv';
  import * as timeago from 'timeago.js'
  import {fade} from "svelte/transition";
  import Delete16 from "carbon-icons-svelte/lib/Delete16";


  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  function remove(){
    dispatch('remove',{id});
  }

  function convertDate(timestamp){
    return timeago.format(new Date(timestamp));
  }

  export let owned = true
  export let showAuthor = false
  export let email
  export let id; //document ID
  export let title;
  export let description;
  export let created; 
  export let map; 
  
</script>

<style>
:global(.card){
  list-style:none;
  margin:0;
  display:grid;
  grid-template-rows: auto auto;
  border: 1px solid rgba(0,0,0,.1);
  border-top: 6px solid rgba(0, 178, 255, 1);
  
  box-shadow: 1px 1px 10px rgba(0,0,0,.05);  
}
:global(.card .cardtop){
  padding:10px;   
  cursor: pointer;
}
:global(.card .cardactions){
  padding: 10px;  
  border-top: 1px solid rgba(0,0,0,.05);
  align-self: end;
}
:global(.card.empty){
  box-shadow: none;
  border: 1px dashed rgba(0,0,0,.1);  
}
h3{
  margin-bottom: 0;
}

.title{
  @apply text-lg font-bold leading-none;
}

</style>

<div class="card">
  <div class="cardtop" on:click={()=>{navigateTo('/#maps/'+id)}}>
    <h3><span class="title">{title}</span></h3>        
    <small>created {convertDate(created)}</small>    
  </div>
  <div class="cardactions">
    {#if owned}
      <span class="cursor-pointer">
        <Delete16 on:click={remove}></Delete16>
      </span>
    {/if}
    {#if showAuthor && email}
      <small class="text-gray-600">{email.split("@").shift()}</small>
    {/if}
  </div>

</div>  